<template>
    <form class="form-horizontal" @submit.prevent="submit()">
            <div class="form-group" :class="{'has-error': errors['nombre']}">
                <label for="nombre" class="col-sm-2 control-label">Titulo</label>
                <div class="col-sm-10">
                    <input type="text" name="nombre" v-model="data.nombre" class="form-control">
                    <div class="help-block" v-for="e in errors['nombre']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['observations']}">
                <label for="observations" class="col-sm-2 control-label">Mensaje de contingencia</label>
                <div class="col-sm-10">
                    <editor id="observations" v-model="data.observations"></editor>
                    <div class="help-block" v-for="e in errors['observations']">{{e}}</div>
                </div>
            </div>
            <div class="form-group" :class="{'has-error': errors['status']}">
                <label for="status" class="col-sm-2 control-label">Desea activar este mensaje</label>
                <div class="col-sm-10">
                    <div class="radio">
                        <label><input type="radio" v-model="data.status" :value="true" /> Si</label>
                        <label><input type="radio" v-model="data.status" :value="false" /> No</label>
                    </div>
                    <div class="help-block" v-for="e in errors['status']">{{e}}</div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <button type="submit" class="btn btn-primary">Guardar</button>
                    <a href="backend/mensajes-feriados" class="btn btn-default">Ir atrás</a>
                </div>
            </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import Editor from "./Editor.vue"; 

    var url2 = baseUrl;

    export default {
        mounted: function() {
            // console.log('Component mounted.');
        },
        data: function() {
            return {
                data: {
                    nombre: '',
                    observations: '',
                    status: false,
                },
                errors: {}
            }
        },
        components:{
            Editor
        },
        methods:{
            submit: function(){
                
                var self = this;

                axios({
                    url: '/backend/formSubmit',
                    method: 'POST',
                    data: self.data,
                }).then(function(response){
                    window.location.replace(url2+'/backend/mensajes-feriados');
                }).catch(function(error){
                    console.log(error)
                    // self.errors = error.response.data.errors;
                });
            }
        }
    }
</script>

<style>

</style>